import React from 'react';
import Header from '../components/Header';

function Devis() {
  return (
    <div>
      <Header/>
    </div>
  );
}

export default Devis;
